import React, { Component, PropTypes } from 'react';
import { Toolbar, ToolbarGroup, ToolbarButton } from 'components/Toolbar';
import * as SvgIcons from 'components/Material/SvgIcons';
import SearchBar from './SearchBar';
import { Shadow, Units } from 'Css';

const css = oxygenCss({
  root: {
    boxShadow: Shadow[1]
  },
  breadCrumb: {
    // marginRight: Units.base,
  }
});

class FileSelectorToolbar extends Component {
  static propTypes = {
    mode: PropTypes.string,
    gridMode: PropTypes.func,
    listMode: PropTypes.func,
    changeDir: PropTypes.func,
    changeSearchFilter: PropTypes.func,
    closeButton: PropTypes.bool,
    breadCrumbs: PropTypes.array
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  static defaultProps = {
    breadCrumbs: [],
    closeButton: false
  };

  changeSearchFilter = searchText => {
    const { changeSearchFilter } = this.props;
    changeSearchFilter(searchText);
  };

  changeDir = directoryId => {
    const { changeDir } = this.props;
    changeDir(directoryId);
  };

  render() {
    const { mode, breadCrumbs, gridMode, listMode, closeButton } = this.props;
    const { getIntlMessage } = this.context;
    return (
      <div className={css.root}>
        <Toolbar dense>
          <ToolbarGroup transparent>
            <ToolbarGroup>
              <ToolbarButton
                tooltip={getIntlMessage('mediaLibrary.thumbView')}
                onTouchTap={gridMode}
                disabled={mode === 'grid'}
              >
                <SvgIcons.ActionViewModule />
              </ToolbarButton>
              <ToolbarButton
                tooltip={getIntlMessage('mediaLibrary.listView')}
                onTouchTap={listMode}
                disabled={mode === 'list'}
              >
                <SvgIcons.ActionViewList />
              </ToolbarButton>
            </ToolbarGroup>
            <ToolbarGroup>
              {breadCrumbs.map(breadCrumb => {
                const { id, name } = breadCrumb;
                return (
                  <ToolbarButton
                    onTouchTap={this.changeDir.bind(this, id)}
                    key={id}
                    className={css.breadCrumb}
                  >
                    {name} /
                  </ToolbarButton>
                );
              })}
            </ToolbarGroup>
          </ToolbarGroup>
          {closeButton && (
            <ToolbarGroup right>
              <ToolbarButton
                tooltip={getIntlMessage('mediaLibrary.close')}
                onTouchTap={this.close}
              >
                <SvgIcons.ContentClear />
              </ToolbarButton>
            </ToolbarGroup>
          )}
        </Toolbar>
        <Toolbar dense>
          <SearchBar onChange={this.changeSearchFilter} fullWidth />
        </Toolbar>
      </div>
    );
  }
}

export default FileSelectorToolbar;



// WEBPACK FOOTER //
// ./src/js/components/MediaLibrary/FileSelectorToolbar.js